import { useFormContext } from 'react-hook-form';

import type { AgreementFormSchema } from '../schemas';

export const useAgreementFormContext = () => {
  const context = useFormContext<AgreementFormSchema>();
  return context;
};
